import  { useEffect, useState, useRef } from "react";
import LoanSummary from "./components/LoanSummary/LoanSummary";
import PaymentDetails from "./components/PaymentDetails/PaymentDetails";
import EMIsAPI from "../../services/emi-api";
import { useLocation } from "react-router-dom";
import { clevertap_loan_repayment_payment_summury__screen } from "../../lib/clevertap-events";

export default function Repayment() {
  const { state } = useLocation();
  const [amount, setAmount] = useState(0);
  const [dueDate, setDueDate] = useState('');
  const isCleverTapLoadEventFire = useRef(false);

  useEffect(() => {
    const fetchRepaymentData = async () => {
      const { getRepaymentAmountAPI } = new EMIsAPI();
      const res = await getRepaymentAmountAPI(state?.isForeClosure);
      if ((res && res?.statusCode === 200) || res?.status === "1") {
        setAmount(res.data.Total_Payable_Amount);
        setDueDate(res.data.RepayDate)
      }
    };

    fetchRepaymentData();
  }, [state?.isForeClosure]);

  useEffect(() => {
    if(amount && !isCleverTapLoadEventFire.current) {
      isCleverTapLoadEventFire.current = true;
      clevertap_loan_repayment_payment_summury__screen({
        amount
      })
    }
  }, [amount, isCleverTapLoadEventFire])

  return (
    <div className="wrapper auto-height bg-white">
      <LoanSummary amount={amount} />
      <PaymentDetails amount={amount} dueDate={dueDate} />
    </div>
  );
}
